import styled from 'styled-components';

const Wrapper = styled.div`
  .dashboard-widget-menu-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .dashboard-widget-menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 160px;
    background: ${(props) => props.theme.colors.widget_background};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    border-radius: 12px;
    overflow: hidden;

    li {
      width: 100%;

      button {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 17px 16px;
        font-family: ManropeBold, sans-serif;
        font-size: 13px;
        line-height: 18px;
        cursor: pointer;
        color: ${(props) => props.theme.colors.text};

        &:hover {
          background: ${(props) => props.theme.colors.inactive};
        }
      }
    }
  }
`;

export default { Wrapper };
